// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2poyS","question":"Question_question__3Flg7","description":"Question_description__3MI0I"};